// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mes-simulation .content {
    margin-top: 0;
    display: flex;
    margin-bottom: 0;
    padding-bottom: 0;
}

.mes-simulation .content > div {
    display: inline-block;
}

.mes-simulation .checkbox-container input{
    border: 2px solid #30006D;
    box-sizing: border-box;
    border-radius: 8px;
}
.mes-simulation .checkbox-container label{
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #171B1E;
}
.mes-simulation .date-exercice {
    position: relative;
    margin-left: auto;
    margin-right: 0;
    display: flex !important;
    justify-content: center;
}

.mes-simulation .loader-parent {
    position: absolute;
    width: 100%;
}

.mes-simulation .loader-parent > div {
    height: 100vh;
    bottom: 0;
}

.mes-simulation .no-such-data {
    margin: 10px auto;
}

.mes-simulation .date-exercice input {
    width: 155px;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #171B1E;
}

.mes-simulation .date-exercice .edit svg {
    font-size: 25px;
    margin-top: -7px;
}

.mes-simulation .sub-cat-input {
    width: 60px;
    margin-right: 5px;
}

/* .mes-simulation .date-exercice input[type="date"]::-webkit-inner-spin-button,
.mes-simulation .date-exercice input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
} */

.mes-simulation .date-exercice p{
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #171B1E;
}

.client-info th {
    height: 100px
}

.client-info td {
    height: 75px;
}

.client-info th span {
    font-style: normal;
    font-weight: 0;
    font-size: 18px;
    line-height: 33px;
    color: #FFFFFF;

}

.mes-simulation .client-info .main-line td span{
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 25px;
    /* identical to box height */
    
    
    color: #171B1E;
}

.mes-simulation .monthTable {
    position: relative;
    height: 176px;
}

.mes-simulation .monthTable table {
    width: 100%;
}

.mes-simulation .monthTable > div {
    position: absolute;
    width: 100%;
}

.mes-simulation .monthTable table thead {
    background-color: white;
}

.mes-simulation .monthTable table thead tr th {
    width: 100px !important;
}

.mes-simulation .monthTable table thead tr {
    border-bottom: 1px solid darkgrey;
}

.mes-simulation .monthTable {
    background-color: white;
}

.mes-simulation .pinkTable table tr {
    background-color: #F4EBF1;
}

.mes-simulation .orangeTable table tr {
    background-color: #FFF9F4;
}

.mes-simulation .monthTable table thead tr th {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #171B1E;
}

.mes-simulation .monthTable table tbody tr td {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #171B1E;
    text-align: center;
}

.mes-simulation .sub-title span{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: #717579;
}

.mes-simulation .client-info .hasAmount .label {
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    color: #FFFFFF;
}

.mes-simulation .client-info .hasAmount div span{
    display: block;
}

.mes-simulation .client-info .main-arrow {
    color: #C6007F;
    font-size: 40px;
}

.mes-simulation .client-info .orange{
    color: #FF9D42
}

.mes-simulation .client-info .sub-row td:first-child {
    padding-left: 40px;
}

.mes-simulation .monthTable input {
    text-align: center;
}

@media (max-width: 1600px) { 
    .mes-simulation .content-table {
        padding-left: 25px;
        background-color: white;
        padding-right: 25px;
        width: calc(100% - 16rem);
        margin-left: 16rem;
    }
}

@media (max-width: 1000px) { 
    .mes-simulation .content-table {
        width: 100%;
        margin-left: 0;
    }

    body {
        padding-bottom: 100px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/mes_simulation.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;;;;GAIG;;AAEH;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;;;IAG5B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;QAClB,uBAAuB;QACvB,mBAAmB;QACnB,yBAAyB;QACzB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".mes-simulation .content {\n    margin-top: 0;\n    display: flex;\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n\n.mes-simulation .content > div {\n    display: inline-block;\n}\n\n.mes-simulation .checkbox-container input{\n    border: 2px solid #30006D;\n    box-sizing: border-box;\n    border-radius: 8px;\n}\n.mes-simulation .checkbox-container label{\n    font-style: normal;\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 25px;\n    color: #171B1E;\n}\n.mes-simulation .date-exercice {\n    position: relative;\n    margin-left: auto;\n    margin-right: 0;\n    display: flex !important;\n    justify-content: center;\n}\n\n.mes-simulation .loader-parent {\n    position: absolute;\n    width: 100%;\n}\n\n.mes-simulation .loader-parent > div {\n    height: 100vh;\n    bottom: 0;\n}\n\n.mes-simulation .no-such-data {\n    margin: 10px auto;\n}\n\n.mes-simulation .date-exercice input {\n    width: 155px;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 25px;\n    color: #171B1E;\n}\n\n.mes-simulation .date-exercice .edit svg {\n    font-size: 25px;\n    margin-top: -7px;\n}\n\n.mes-simulation .sub-cat-input {\n    width: 60px;\n    margin-right: 5px;\n}\n\n/* .mes-simulation .date-exercice input[type=\"date\"]::-webkit-inner-spin-button,\n.mes-simulation .date-exercice input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    display: none;\n    -webkit-appearance: none;\n} */\n\n.mes-simulation .date-exercice p{\n    font-style: normal;\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 25px;\n    color: #171B1E;\n}\n\n.client-info th {\n    height: 100px\n}\n\n.client-info td {\n    height: 75px;\n}\n\n.client-info th span {\n    font-style: normal;\n    font-weight: 0;\n    font-size: 18px;\n    line-height: 33px;\n    color: #FFFFFF;\n\n}\n\n.mes-simulation .client-info .main-line td span{\n    font-style: normal;\n    font-weight: bold;\n    font-size: 16px;\n    line-height: 25px;\n    /* identical to box height */\n    \n    \n    color: #171B1E;\n}\n\n.mes-simulation .monthTable {\n    position: relative;\n    height: 176px;\n}\n\n.mes-simulation .monthTable table {\n    width: 100%;\n}\n\n.mes-simulation .monthTable > div {\n    position: absolute;\n    width: 100%;\n}\n\n.mes-simulation .monthTable table thead {\n    background-color: white;\n}\n\n.mes-simulation .monthTable table thead tr th {\n    width: 100px !important;\n}\n\n.mes-simulation .monthTable table thead tr {\n    border-bottom: 1px solid darkgrey;\n}\n\n.mes-simulation .monthTable {\n    background-color: white;\n}\n\n.mes-simulation .pinkTable table tr {\n    background-color: #F4EBF1;\n}\n\n.mes-simulation .orangeTable table tr {\n    background-color: #FFF9F4;\n}\n\n.mes-simulation .monthTable table thead tr th {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #171B1E;\n}\n\n.mes-simulation .monthTable table tbody tr td {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 19px;\n    color: #171B1E;\n    text-align: center;\n}\n\n.mes-simulation .sub-title span{\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n    color: #717579;\n}\n\n.mes-simulation .client-info .hasAmount .label {\n    font-style: normal;\n    font-weight: 800;\n    font-size: 16px;\n    line-height: 22px;\n    color: #FFFFFF;\n}\n\n.mes-simulation .client-info .hasAmount div span{\n    display: block;\n}\n\n.mes-simulation .client-info .main-arrow {\n    color: #C6007F;\n    font-size: 40px;\n}\n\n.mes-simulation .client-info .orange{\n    color: #FF9D42\n}\n\n.mes-simulation .client-info .sub-row td:first-child {\n    padding-left: 40px;\n}\n\n.mes-simulation .monthTable input {\n    text-align: center;\n}\n\n@media (max-width: 1600px) { \n    .mes-simulation .content-table {\n        padding-left: 25px;\n        background-color: white;\n        padding-right: 25px;\n        width: calc(100% - 16rem);\n        margin-left: 16rem;\n    }\n}\n\n@media (max-width: 1000px) { \n    .mes-simulation .content-table {\n        width: 100%;\n        margin-left: 0;\n    }\n\n    body {\n        padding-bottom: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
